import React from 'react'
import styled from 'styled-components'
const Container = styled.div`
  width: 100%;
  height: 100%;
`
export const YouTubeEmbed = ({ videoId }) => {
  return (
    <Container>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title='YouTube video player'
        border='0'
        width='100%'
        height='100%'
        allowFullScreen
      ></iframe>
    </Container>
  )
}
